var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{staticClass:"checkbox-form__group",attrs:{"description":_vm.item.helpText}},[_c('b-form-checkbox',{attrs:{"value":"1","unchecked-value":"0"},model:{value:(_vm.item.value),callback:function ($$v) {_vm.$set(_vm.item, "value", $$v)},expression:"item.value"}},[_vm._v(" "+_vm._s(_vm.item.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }